/* eslint-disable camelcase */
import { dateFormat } from '@tencent/pmd-tools/lib/time';

/**
 * 获取子活动详情对象
 * @param eventInfo(必传) 后台返回的eventinfo
 * @return childInfo  子活动详情对象
 */
export function getChildInfo(eventInfo, isOnline, remainHc, groupType, teamMemberApplyNum) {
  const childInfo = {};
  const { child_info } = eventInfo;
  childInfo.siteId = child_info.site_id;
  childInfo.stage = child_info.stage;
  childInfo.parentId = child_info.parent_id;
  childInfo.childId = child_info.child_id;
  childInfo.gameTagPic = eventInfo.game_tag_pic;
  childInfo.headPic = child_info.child_pic;
  childInfo.logoPic = child_info.logo_pic;
  childInfo.childName = child_info.child_name;
  childInfo.applyStartTime = child_info.join_begin;
  childInfo.applyEndTime = child_info.join_end;
  childInfo.matchStartTime = child_info.act_start_time;
  childInfo.matchStartText = `${dateFormat(new Date(child_info.act_start_time * 1000), 'M-d hh:mm')}开赛`;
  childInfo.matchEndTime = child_info.act_end_time;
  childInfo.rewards = getRewardsData(child_info.general_reward_desc);
  childInfo.addressName = child_info.address_name;
  childInfo.isOnline = isOnline || false; // 是否是线上赛
  childInfo.groupType = groupType || 0;  // 3：循环赛， 4：淘汰赛  5：杯赛
  if (!isNaN(eventInfo.distance)) {
    if (eventInfo.distance > 1000) {
      childInfo.distanceText = `${(eventInfo.distance / 1000).toFixed(1)}km`;
    } else {
      childInfo.distanceText = `${eventInfo.distance}m`;
    }
  } else {
    childInfo.distanceText = '';
  }

  childInfo.applyState = eventInfo.state; // 报名状态 1可报名 2已报名 3不可报名 4已预报名
  childInfo.remainHc = remainHc || 0; // 比赛剩余可报名队伍数量
  childInfo.matchStatus = eventInfo.disp_status; // 展示状态  1报名中 2待比赛 3比赛中 4已结束
  childInfo.matchAdminStatus = eventInfo.status; // 状态 1未审核 2已通过 3已下线
  childInfo.joinNumText = child_info.join_num ? `${child_info.join_num}人参与` : '';
  // 参赛账号类型 0不限制 1 只允许qq账号报名, 2只允许微信账号报名
  childInfo.utypeLimit = child_info.match_rule_cfg && child_info.match_rule_cfg.utype_limit;
  childInfo.gameMode = child_info.match_rule_cfg && child_info.match_rule_cfg.game_mode;  // 1:征召，2:自选
  childInfo.signinStart = child_info.match_rule_cfg && child_info.match_rule_cfg.signin_start_time; // 签到开始时间
  childInfo.signinEnd = child_info.match_rule_cfg && child_info.match_rule_cfg.signin_end_time;// 签到结束时间
  childInfo.lng = child_info.lng;
  childInfo.lat = child_info.lat;
  childInfo.hasMemberApply = teamMemberApplyNum && teamMemberApplyNum > 0;
  return childInfo;
}

export function mockChildInfo() {
  const childInfo = {};
  childInfo.logoPic = 'https://dummyimage.com/96x96';
  childInfo.childName = '天美L1&L2工作室';
  childInfo.applyStartTime = 1620886373;
  childInfo.applyEndTime = 1621051200;
  childInfo.matchStartTime = 1621267200;
  childInfo.matchEndTime = 1621872000;
  childInfo.headPic = '';
  childInfo.rewards = [{
    title: '冠军',
    text: '5000元现金、限定头像框、500铭文碎片、随机英雄，随机皮肤',
  },
  {
    title: '亚军',
    text: '3000元现金、限定头像框、500铭文碎片',
  },
  {
    title: '季军',
    text: '1000元现金、限定头像框、500铭文碎片',
  },
  ];
  childInfo.addressName = '四川省成都市武侯区天府三街腾讯大厦A座';

  childInfo.applyState = 2; // 报名状态 1可报名 2已报名 3不可报名
  childInfo.matchStatus = 1; // // 展示状态  1报名中 2待比赛 3比赛中 4已结束
  // 参赛账号类型 0不限制 1 只允许qq账号报名, 2只允许微信账号报名
  childInfo.utypeLimit = 1;
  childInfo.lng = 44.23;
  childInfo.lat = 168.343;
  return childInfo;
}

export function getChildBasicInfo({ childBasicInfo,
  childProStatusInfo,
  childTeamTotal,
  siteRuleInfo,
  battleRoomConf }) {
  const childInfo = {};
  if (!childBasicInfo) {
    return childInfo;
  }
  childInfo.siteId = childBasicInfo.site_id;
  childInfo.parentId = childBasicInfo.parent_id;
  childInfo.childId = childBasicInfo.child_id;
  childInfo.virtualTag = childBasicInfo.virtual_tag;
  childInfo.childName = childBasicInfo.child_name;// 子活动名
  childInfo.logoPic = childBasicInfo.logo_pic;// 子活动logo
  childInfo.backgroundPic = childBasicInfo.background_pic;// 赛事背景图
  childInfo.childPic = childBasicInfo.child_pic; // 子活动头图
  childInfo.placeId = childBasicInfo.place_id;// 所属区域(东北大区,西南大区,等等)
  childInfo.addressName = childBasicInfo.address_name;// 活动地点简称
  childInfo.address = childBasicInfo.address;// 活动详细地址
  childInfo.lat = childBasicInfo.lat;// 地址纬度,
  childInfo.lng = childBasicInfo.lng;// 地址经度,
  childInfo.province = childBasicInfo.province;// 省份id
  childInfo.city = childBasicInfo.city;// 城市id
  childInfo.dispRewardInfo = getDispRewardInfo(childBasicInfo.disp_reward_info);// 展示奖励列表
  childInfo.applyStartTime = childBasicInfo.join_begin; // 报名周期开始时间(主活动不设报名时不需要)
  childInfo.applyEndTime = childBasicInfo.join_end; // 报名周期结束时间(主活动不设报名时不需要)
  childInfo.signinStart = childBasicInfo.signin_start_time; // 签到开始时间
  childInfo.signinEnd = childBasicInfo.signin_end_time;// 签到结束时间
  childInfo.matchStartTime = childBasicInfo.act_start_time; // 比赛开始时间
  childInfo.matchEndTime = childBasicInfo.act_end_time; // 比赛结束时间
  childInfo.groupType = childBasicInfo.group_type || 0;// 3循环赛 4单淘 5杯赛 7自定义
  childInfo.utypeLimit = childBasicInfo.utype_limit || 0;// 账号限制 1 只允许qq账号报名, 2只允许微信账号报名
  childInfo.scheduleStage = childBasicInfo?.schedule_stage || 0;// 10000取消比赛  11000提前结束比赛
  childInfo.nodeId = childBasicInfo?.node_id || '';// 组织id
  childInfo.kvList = childBasicInfo?.kv_list || [];// KV图
  if (childBasicInfo.disp_reward_info?.length > 0) {
    childInfo.rewards = childBasicInfo.disp_reward_info;
  }
  if (childProStatusInfo) {
    // 比赛当前状态，0:未开始报名； 100:报名中; 200: 比赛中 (报名结束且生成赛程); 300: 比赛结束; 400:赛事取消
    childInfo.matchStatus = childProStatusInfo.child_cur_st || 0;
    childInfo.userStatus = childProStatusInfo.player_cur_st || 0;// 参赛者当前状态
  }
  if (childTeamTotal) {
    childInfo.fullTeamNums = childTeamTotal.full_team_nums || 0;// 满员队伍数
    childInfo.notFullTeamNums = childTeamTotal.not_full_team_nums || 0;// 未满5人队伍
    childInfo.teamNums = childTeamTotal.team_nums || 0;// 总队伍数
  }
  if (siteRuleInfo?.rule_item_list?.[0]?.text2) {
    childInfo.ruleText = initRule(siteRuleInfo.rule_item_list[0].text2) ;
  }
  if (battleRoomConf) {
    childInfo.gameMode = battleRoomConf.game_mode;  // 游戏模式 1征召 2自选
    childInfo.battleMode = battleRoomConf.battle_mode; // 对战方式 1:1v1 3:3v3 0:5v5
  }
  return childInfo;
}

function getDispRewardInfo(dispRewardInfo) {
  const rewards = [];
  if (!dispRewardInfo) {
    return rewards;
  }
  for (let i = 0; i < dispRewardInfo.length; i++) {
    rewards.push(getRewardItem(dispRewardInfo[i]));
  }
}

function getRewardItem(item) {
  const reward = {
    title: item.title || '',
    text: item.text || '',
    pic: item.pic || '',
  };
  return reward;
}

function getRewardsData(rewardText) {
  let rewards = [];
  try {
    if (rewardText) {
      rewards =  JSON.parse(decodeURIComponent(rewardText));
    }
  } catch (e) {
    rewards = [];
  }
  return rewards;
}

function initRule(rule) {
  return rule.replace(/\n/g, '<br>');
}


